var currentCat = 0;
function displayCategoryInfos(id) {
	if (currentCat !== 0) {
		document.getElementById('modifyCategory' + currentCat).style.display = "none";
	}
	document.getElementById('modifyCategory' + id).style.display = "block";
	var pos = getPosition(document.getElementById('actions' + id));
	var tabWidth = document.getElementById('actions' + id).offsetWidth;

	document.getElementById('modifyCategory' + id).style.left = (pos.x + tabWidth + 20) + "px";
	document.getElementById('modifyCategory' + id).style.top = (pos.y) + "px";
	currentCat = id;
}
function changeValue(id, value) {
	if (document.getElementById(id).value === '') {
		document.getElementById(id).value = value;
	}
}
function displayBlockValue(sel, exception, id) {
	if (sel.selectedIndex == exception || Array.isArray(exception) && exception.indexOf(sel.selectedIndex) !== -1) {
		document.getElementById(id).style.display = "none";
	} else {
		document.getElementById(id).style.display = "block";
	}
}
function adminSendNotValidEmail(accountId) {
	ajax('/action/pmiSendNotValid?accountId=' + accountId, adminSendNotValidEmailComplete);
}
function changeStates(value, ca, us, page) {
	var p = $(".province-select", page)[0],
		s = $(".state-select", page)[0],
		o = $(".other-province-select", page)[0],
		notAdmin = $("#adminNotLogged", page).attr("value");

	if (p !== undefined && s !== undefined && o !== undefined) {
		p.className = p.className.replace("required", "").trim();
		s.className = s.className.replace("required", "").trim();
		o.className = o.className.replace("required", "").trim();
		if (value === ca) {
			p.style.display = "block";
			s.style.display = "none";
			o.style.display = "none";
			if (notAdmin === "true") {
				p.className += " required";
			}
			p.onchange();
		}
		else if (value === us) {
			p.style.display = "none";
			s.style.display = "block";
			o.style.display = "none";
			if (notAdmin === "true") {
				s.className += " required";
			}
			s.onchange();
		}
		else {
			p.style.display = "none";
			s.style.display = "none";
			o.style.display = "block";
			if (notAdmin === "true") {
				o.className += " required";
			}
			o.onchange();
		}
	}
}
function countryChoice(select) {
	var $parent = $('.province-select, .state-select, .other-province-select').parent('.useSelect');
	var span = $parent.find('span');

	changeStates($(select).val(), 'CA', 'US', 'body');

	if (select.value == 'CA' || select.value == 'CAN') {
		span.html($('.province-select option:selected').text());
	}
	else if (select.value == 'US' || select.value == 'USA') {
		span.html($('.state-select option:selected').text());
	}
	else {
		span.html($('.other-province-select option:selected').text());
	}
}
function changeCategory(pageName, sel, month, year, calendar, admin, zone, pduType) {
	var categoryId;
	if (sel.options[sel.selectedIndex].value === "") {
		categoryId = -1;
	} else {
		categoryId = sel.options[sel.selectedIndex].value;
	}
	var pdu = "";
	if (pduType !== '') {
		pdu = "&pduType=" + pduType;
	}
	if (calendar) {
		if (admin) {
			window.location = pageName + '?month=' + month + '&year=' + year + '&categoryId=' + categoryId + '&calendar-view&zone=' + zone + pdu;
		} else {
			window.location = pageName + '?month=' + month + '&year=' + year + '&categoryId=' + categoryId + '&calendar-view' + pdu;
		}
	} else {
		if (admin) {
			window.location = pageName + '?month=' + month + '&year=' + year + '&categoryId=' + categoryId + '&zone=' + zone + pdu;
		} else {
			window.location = pageName + '?month=' + month + '&year=' + year + '&categoryId=' + categoryId + pdu;
		}
	}
}
function closeWindowDescr(id, wrapper) {
	$(id, wrapper).fadeOut(function () {
		$(this).removeAttr('style');
		$('#full-calendar, .pmi-event-container, .calendarItemPhone', wrapper).removeClass('selected');
	});
}
function openDescr(id, elmt, wrapper) {
	if ($(elmt).hasClass('selected')) {
		closeWindowDescr('#event' + id, wrapper);
	} else {
		var pos = $(elmt).position();
		var elmtWidth = $(elmt).outerWidth();
		var elmtHeight = $(elmt).outerHeight();
		var posEvent = $('#event' + id).position();
		var widthEvent = $('#event' + id, wrapper).outerWidth();
		var heightEvent = $('#event' + id, wrapper).outerHeight();
		var centeredDescPos = pos.left - widthEvent / 2 + elmtWidth / 2;
		var leftPosArrow = posEvent.left + (widthEvent / 2);

		$('#full-calendar, .pmi-event-container, .calendarItemPhone', wrapper).removeClass('selected');
		$('#calendarItemPhone' + id, wrapper).addClass('selected');
		$('#full-calendar', wrapper).addClass('selected');
		$(elmt, wrapper).addClass('selected');
		$('#event' + id + ' .pmi-event-arrow').css({ 'left': leftPosArrow + 'px', 'top': heightEvent + 'px' });
		$('#event' + id, wrapper).css({ 'top': pos.top - heightEvent - 15 + "px" });
		$('.descrWindow').css({ 'left': centeredDescPos + 'px' });
		$('#event' + id, wrapper).fadeIn(function () {
			$('#event' + id, wrapper).css({ 'display': 'block' });
		});


	}
}
function goToBloc(bloc) {
	var blocOffsetTop = $('#' + bloc).offset().top;
	$('html,body').animate({
		'scrollTop': blocOffsetTop
	});
}
function goToObjectDom($object) {
	var objectDomOffsetTop = $object.offset().top;
	$('html,body').animate({
		'scrollTop': objectDomOffsetTop
	});
}
function checkEmail(value) {
	var filter = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
	return filter.test(value);
}
function checkPhoneFax(value) {
	var filter = /^\d{3}[\s{0,1}|\-{0,1}]{0,1}\d{3}[\s{0,1}|\-{0,1}]{0,1}\d{4}$/;
	return filter.test(value);
}
function controlFieldsForm($form, param) {
	var bool = [];
	var lengthAtLeast = $form.find('.atLeast:checked').length;
	$form.find('.required:not(.atLeast)').each(function () {
		var $required = $(this);
		var val = $required.val();
		var isEmpty = $required.css('display') != 'none' && (val === '' || val === null);
		var notChecked = $required.hasClass('radio') && $form.find('.radio[name="' + $required.attr('name') + '"]:checked').length === 0 || $required.hasClass('checkbox') && !$required.is(':checked');
		var invalidEmail = $required.hasClass('email') && !checkEmail(val);
		var invalidPhone = ($required.hasClass('phone') || $required.hasClass('fax')) && !checkPhoneFax(val);
		if (isEmpty || notChecked || invalidEmail || invalidPhone) {
			bool.push(false);
			$required.addClass('error');
			$required.parent().addClass('error');
		} else {
			bool.push(true);
			$required.removeClass('error');
			$required.parent().removeClass('error');
		}
	});
	$form.find('#priceAll, #priceMember, #priceStudent').each(function () {
		var $dis = $(this);
		var val = $dis.val() !== "" ? parseFloat($dis.val()) : 0;
		if (val < 0 || isNaN(val)) {
			bool.push(false);
			$dis.addClass('error').parent().addClass('error');
		} else {
			bool.push(true);
			$dis.removeClass('error').parent().removeClass('error');
		}
	});

	var fields = $form.find($('.field'));
	fields.each(function () {
		if ($(this).find('select').hasClass('error')) {  // for select tags
			$(this).addClass('error');
		} else {
			$(this).removeClass('error');
		}
	});

	if ($form.find('.atLeast').length > 0) {
		if (lengthAtLeast > 0) {
			$form.find('.atLeast').closest('.field').removeClass('error');
			bool.push(true);
		}
		else {
			$form.find('.atLeast').closest('.field').addClass('error');
			bool.push(false);
		}
	}
	if (param === 'contact') {
		if ($.inArray(false, bool) === -1) {
			$form.find('.errorMessage').removeAttr('style');
			sendContactForm(true, 4);
		} else {
			$form.find('.errorMessage').css({ 'display': 'block' });
			goToObjectDom($form);
			return false;
		}
	} else if (param === 'checkout') {
		if ($form.find('*[name="paymentType"]:checked').val() === 'card') {
			var ccCard = $form.find('*[name="ccCard"]');
			var expMM = $form.find('*[name="expMM"]');
			var expYY = $form.find('*[name="expYY"]');
			var cvv = $form.find('*[name="cvv"]');
			if (ccCard.val() === '' || expMM.val() === '' || expYY.val() === '' || cvv.val() === '') {
				if (ccCard.val() === '')
					ccCard.addClass('error');
				if (expMM.val() === '')
					expMM.parent().addClass('error');
				if (expYY.val() === '')
					expYY.parent().addClass('error');
				if (cvv.val() === '')
					cvv.addClass('error');
				bool.push(false);
			}
			else
				bool.push(true);
		}
		if ($.inArray(false, bool) === -1) {
			$form.find('.errorMessage').removeAttr('style');
			fillRecapCheckout($form);
			goToCheckoutStep(2);
		} else {
			$form.find('.errorMessage').css({ 'display': 'block' });
			goToObjectDom($form);
			return false;
		}
	} else {
		if ($.inArray(false, bool) === -1) {
			$form.find('.errorMessage').hide();
			$form[0].submit();
		} else {
			$form.find('.errorMessage').show();
			goToObjectDom($form);
			return false;
		}
	}
	return false;
}
function fillRecapCheckout(form) {
	var fname = form.find('*[name="firstName"]').val();
	var lname = form.find('*[name="lastName"]').val();
	var email = form.find('*[name="email"]').val();
	var address = form.find('*[name="street"]').val();
	var city = form.find('*[name="city"]').val();
	var state = form.find('*[name="province"]').val();
	var zip = form.find('*[name="postalCode"]').val();
	var country = form.find('*[name="country"]').val();
	var paymentType = form.find('*[name="paymentType"]:checked').val();
	var ccCard = form.find('*[name="ccCard"]').val();
	var expMM = form.find('*[name="expMM"]').val();
	var expYY = form.find('*[name="expYY"]').val();
	$('#recap-checkout-fname').text(fname);
	$('#recap-checkout-lname').text(lname);
	$('#recap-checkout-email').text(email);
	$('#recap-checkout-address').text(address);
	$('#recap-checkout-city').text(city);
	$('#recap-checkout-state').text(state);
	$('#recap-checkout-zip').text(zip);
	$('#recap-checkout-country').text(country);
	$('#recap-checkout-payment-type').text(paymentType);
	if (paymentType === 'card') {
		$('#recap-checkout-card-number').text(ccCard);
		$('#recap-checkout-expmm').text(expMM);
		$('#recap-checkout-expyy').text(expYY);
		$('#recap-checkout-expmm').show();
		$('#recap-checkout-expyy').show();
		$('#recap-checkout-expmm').parent().show();
	} else {
		$('#recap-checkout-expmm').parent().hide();
		$('#recap-checkout-expmm').hide();
		$('#recap-checkout-expyy').hide();
	}
}
function goToCheckoutStep(step) {
	$('.checkout-pagination .checkout-pagination-step').each(function () {
		var $this = $(this);
		var dataStep = $this.attr('data-step');
		if (dataStep > step)
			$this.removeClass('selected active');
		else if (dataStep === step)
			$this.addClass('selected');
		else
			$this.addClass('active');
	});
	$('.checkout-steps.selected').fadeOut(function () {
		$(this).removeClass('selected').addClass('hide');
		$(this).removeAttr('style');
		$('.checkout-steps[data-step="' + step + '"]').fadeIn(function () {
			$(this).removeClass('hide').addClass('selected');
			$(this).removeAttr('style');
			goToObjectDom($('.checkout-steps[data-step="' + step + '"]'));
		});
	});
}

function applyCredit(id) {
	var value = document.getElementById('pmi-attendance-credit').value;
	if (confirm("Veuillez confirmer qu'un montant de " + value + "$ sera cr\xE9diter \xE0 tous les comptes des gens coch\xE9s \"Particip\xE9\".")) {
		ajax('/action/pmiAttended?id=' + id + "&credit=" + value, applyCreditCompleted);
	}
}
function applyCreditCompleted(response) {
	alert('Le cr\xE9dit a \xE9t\xE9 appliqu\xE9 et les participants ont re\xE7u un courriel de confirmation avec le montant.');
}
function openTransfer(id, eventId) {
	var transfer = $("#" + id + "-" + eventId);
	if (transfer.css("display") != "none") {
		transfer.slideUp();
		document.getElementById('plusTransfer' + "-" + eventId).style.display = "inline-block";
		document.getElementById('minusTransfer' + "-" + eventId).style.display = "none";
	}
	else {
		transfer.slideDown(function() {
			transfer.css('overflow', 'visible');
		});
		document.getElementById('plusTransfer' + "-" + eventId).style.display = "none";
		document.getElementById('minusTransfer' + "-" + eventId).style.display = "inline-block";
	}
}

function updatePaymentCC() {
	var id = document.getElementById('cc-update-id').value;
	var ccCard = document.getElementById('cc-update-ccCard').value;
	var mm = document.getElementById('cc-update-expMM');
	var expMM = mm.options[mm.selectedIndex].value;
	var yy = document.getElementById('cc-update-expYY');
	var expYY = yy.options[yy.selectedIndex].value;
	var cvv = document.getElementById('cc-update-CVV').value;
	var sendInvoice = document.getElementById('cc-update-sendInvoice').checked ? '&sendInvoice=true' : '';
	var qstr = '?paid=true&id=' + id + '&ccCard=' + ccCard + '&expMM=' + expMM + '&expYY=' + expYY + '&CVV=' + cvv + sendInvoice;
	ajax('/action/pmiUpdatePayment' + qstr, updatePaymentCCComplete);
}
function updatePaymentCCComplete(response) {
	if (response.indexOf("failed") !== -1) {
		alert(response);
	} else {
		location.reload();
	}
}

function pmiAttended(chkbox, id) {
	ajax('/action/pmiAttended?id=' + (id ? id : chkbox.value) + '&attended=' + chkbox.checked);
}
function pmiAttendedAll(chkbox, cls) {
	var chkd = chkbox.checked;
	var boxes = document.getElementsByClassName(cls ? cls : chkbox.value);
	var c = boxes.length;

	if (c > 0) {
		ajaxBlackout(true);
		for (var i = 0; i < boxes.length; i++) {
			var box = boxes[i];
			if (box.checked === chkd) {
				c--;
			} else {
				ajax('/action/pmiAttended?id=' + box.value + '&attended=' + chkd,
					_complete, true, box);
			}
		}
	}

	function _complete(response, box) {
		box.checked = chkd;
		if (--c <= 0) {
			ajaxBlackout(false);
		}
	}
}

function sendContactForm(validate, count) {
	var subject = document.getElementById('contactForm-subject').value;
	var email = document.getElementById('contactForm-email').value;
	var targetEmail = (document.getElementById('targetEmail') ? document.getElementById('targetEmail').value : "");
	var content = null;
	try {
		content = tinyMCE.get('contactForm-content').getContent();
	} catch (exception) {
		content = document.getElementById('contactForm-content').value;
	}

	var appendField = "";
	if (document.getElementById('fieldName1') !== null) {
		var total = 9;
		if (count) {
			total = count;
		}
		for (var i = 1; i < total; i++) {
			appendField += "&fieldName" + i + "=" +
				encodeURIComponent(document.getElementById('fieldName' + i).value);
			if (document.getElementById('field' + i).type === "checkbox") {
				if (document.getElementById('field' + i).checked) {
					appendField += "&field" + i + "=checked.";
				} else {
					appendField += "&field" + i + "=not checked.";
				}
			} else {
				appendField += "&field" + i + "=" +
					encodeURIComponent(document.getElementById('field' + i).value);
			}
		}
		appendField += "&count=" + total + "&targetEmail=" + targetEmail;
	}
	var captcha = document.getElementById('contactForm-captcha');
	if (captcha) {
		appendField += '&captcha=' + encodeURIComponent(captcha.value);
	}

	ajax(actionPath + "contactUs?subject=" + encodeURIComponent(subject) + 
		"&email=" + encodeURIComponent(email) + 
		"&content=" + encodeURIComponent(content) + 
		appendField, sendContactFormEmailConfirm);

}


function canadaPC(code) {
	var filter = /^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJKLMNPRSTVWXYZ]( )?\d[ABCEGHJKLMNPRSTVWXYZ]\d$/i;
	return filter.test(code);
}
function usaZIP(code) {
	var filter = /^\d{5}([ \-]\d{4})?$/;
	return filter.test(code);
}
function chkPhoneNumber(value) {
	//var re = /((?:\+|00)[17](?: |\-)?|(?:\+|00)[1-9]\d{0,2}(?: |\-|\.)?|(?:\+|00)1\-\d{3}(?: |\-)?)?(0\d|\([0-9]{3}\)|[1-9]{0,3})(?:((?: |\-)[0-9]{2}){4}|((?:[0-9]{2}){4})|((?: |\-)[0-9]{3}(?: |\-)[0-9]{4})|([0-9]{7}))/;
	var re = /^(((\+?[0-9]{1,3} )?\([0-9]{3}\) [0-9]{3}\-[0-9]{4}|(\+?[0-9]{1,3}[\-])?[0-9]{3}\-[0-9]{3}\-[0-9]{4}|(\+?[0-9]{1,3}[\.])?[0-9]{3}\.[0-9]{3}\.[0-9]{4})|\+?[0-9 ]{10,20})( ?(x|ext|extension)[\. ]?\d{1,6})?$/;
	return re.test(value);
}
function sanitizePhone(value) {
	var raw = value.substring(0).replace(/[\+\(\)\.\- ]/g, "");
	try {
		var ext = raw.search(/(extension|ext|x)/);
		if (ext > -1) raw = raw.substring(0, ext);
		var group = [raw.substr(-7, 3), raw.substr(-4)];
		if (raw.length > 7) group.unshift(raw.substr(-10, 3));
		if (raw.length > 10) group.unshift(raw.substr(0, raw.length - 10));
		return (value.match(/\+/) ? "+" : "") + group.join("-");
	} catch (ex) {
		return raw;
	}
}
function chkNameField(value) {
	var re = /^(?:[a-z\u00C0-\u024F]+['\.\- ]?[a-z\u00C0-\u024F]?)+$/i;
	return re.test(value);
}
function sanitizeName(value) {
	var aa = value.split(" ");
	for (var i = 0; i < aa.length; i++) {
		var ab = aa[i].split("-");
		for (var j = 0; j < ab.length; j++) {
			var ac = ab[j].split(".");
			for (var k = 0; k < ac.length; k++) {
				var ad = ac[k];
				ac[k] = ad.substr(0, 1).toUpperCase() + ad.substr(1).toLowerCase();
			}
			ab[j] = ac.join(".");
		}
		aa[i] = ab.join("-");
	}
	return aa.join(" ");
}
function chkAccForm(form) {
	var $form = $(form);
	var valid = true;

	$form.find(".inputField, .country-select, .selected-province").each(function () {
		var $inp = $(this);
		var $err = $inp.closest(".field").find(".errorMessage");
		var val = $inp.val().trim().replace(/\s+/g, " ");
		var isEmpty = val === "";
		var pass = true;

		switch ($inp.attr("name")) {
			case "pmiNumber":
				if (!isEmpty) pass = !isNaN(val);
				break;
			case "firstName":
			case "lastName":
				pass = chkNameField(val) && !isEmpty;
				if (pass) val = sanitizeName(val);
				break;
			case "city":
			case "country":
			case "street":
			case "preferredLanguage":
				pass = !isEmpty;
				break;
			case "phoneNumber":
				pass = chkPhoneNumber(val);
				if (pass) val = sanitizePhone(val);
				break;
			case "email":
				val = val.toLowerCase();
				pass = checkEmail(val);
				break;
			case "email2":
				val = val.toLowerCase();
				if (!isEmpty) pass = checkEmail(val);
				break;
			case "postalCode":
				val = val.toUpperCase().replace(" ", "");
				pass = !isEmpty;
				if (pass) {
					var country = $("#acntCountry").val();
					if (country === "CA") pass = canadaPC(val);
					if (country === "US") pass = usaZIP(val);
				}
				break;
			default:
				if ($inp.hasClass("required")) pass = !isEmpty;
				break;
		}
		$inp.val(val);
		if (!pass) {
			valid = false;
			$inp.addClass("error");
			$inp.parent(".useSelect").addClass("error");
			$err.show();
		} else {
			$inp.removeClass("error");
			$inp.parent(".useSelect").removeClass("error");
			$err.hide();
		}
	});
	if (valid) $form[0].submit();
}

function getMultiOptionsValue(sel) {
	var opts = sel.options;
	var val = "";
	for (var i = 0; i < opts.length; i++) {
		var o = opts[i];
		if (o.selected) val += (o.value) + ";";
	}
	sel.previousElementSibling.value = val;
}
function ajaxAddProducts(form) {
	var elems = form.elements,
		str = "",
		list = [],
		c = 0,
		msge = document.querySelector(".import-p-p-msg");

	var _complete = function (response) {
		c++;
		if (c >= list.length) {
			msge.innerHTML = "> complete " + c + "/" + list.length;
			msge.style.color = response.match("success") ? "#009448" : "#e11e26";
		} else {
			msge.innerHTML = "> importing... " + c + "/" + list.length;
		}
	};

	for (var i = 0; i < elems.length; i++) {
		var el = elems[i];
		if (el.hasAttribute("name") && el.name !== "") {
			if (el.name === "email") {
				if (el.value.trim() === "") {
					return false;
				} else {
					var emails = el.value.replace(/\s/g, "");
					list = emails.split(",");
				}
			} else {
				str += (str === "" ? "?" : "&") + el.name + "=" + el.value;
			}
		}
	}
	if (list.length > 0) {
		msge.innerHTML = "> importing... 0/" + list.length;
		msge.style.color = "#d8ce0a";
	}
	for (var j = 0; j < list.length; j++) {
		var em = list[j].trim();
		if (em !== "") {
			var data = str + "&email=" + em;
			ajax(form.action + encodeURI(data), _complete, true);
		}
	}
}

// $(window).load(activateGlgAutocomplete);
// function activateGlgAutocomplete() {
// 	var searchInput = document.getElementById("street");
// 	if (searchInput) {
// 		var autocomplete = new google.maps.places.Autocomplete(searchInput);
// 		google.maps.event.addListener(autocomplete, 'place_changed', function () {
// 			addressSearch();
// 		});
// 	}
// }
// function addressSearch(addr) {
// 	var searchInput = document.getElementById("street");
// 	var coorUrl = (addr !== undefined) ? addr : searchInput.value;
// 	var geocoder = new google.maps.Geocoder();
// 	var cp, street, city, province, country;

// 	var getLocation = function (results, status) {
// 		var strNbr = "";
// 		for (var i = 0; i < results[0].address_components.length; i++) {
// 			var component = results[0].address_components[i];
// 			var sname = component.short_name;
// 			switch (component.types[0]) {
// 				case "postal_code": cp = sname;
// 					break;
// 				case "street_number": strNbr = sname;
// 					break;
// 				case "locality": city = sname;
// 					break;
// 				case "administrative_area_level_1": province = sname;
// 					break;
// 				case "country": country = sname;
// 					break;
// 				case "route": street = sname;
// 					break;
// 			}
// 		}
// 		if (!city && province) {
// 			city = province;
// 		}
// 		street = (strNbr + " " + street).trim();
// 		if (status === google.maps.GeocoderStatus.OK) {
// 			updateAddress();
// 		}
// 	};
// 	var updateAddress = function () {
// 		try {
// 			document.getElementById("street").value = !street ? "" : street;
// 		} catch (ex) { }
// 		try {
// 			document.getElementById("city").value = !city ? "" : city;
// 		} catch (ex) { }
// 		try {
// 			document.getElementById("postalCode").value = !cp ? "" : cp;
// 		} catch (ex) { }
// 		try {
// 			var provinceId = "acntProvince" + (country === "CA" ? "1" : country === "US" ? "2" : "");
// 			var provinceEl = document.getElementById(provinceId);
// 			provinceEl.value = province;
// 			if (provinceEl.selectedIndex === -1) {
// 				provinceEl.value = "XX";
// 			}
// 			triggerEvent(provinceEl, "change");
// 		} catch (ex) { }
// 		try {
// 			var countryEl = document.getElementById("acntCountry");
// 			countryEl.value = country;
// 			triggerEvent(countryEl, "change");
// 		} catch (ex) { }

// 		$(".useSelect").each(function () {
// 			var $in = $(this).find("select");
// 			if ($in.filter(".selected").length !== 0) {
// 				$in = $in.filter(".selected");
// 			}
// 			if ($in.length !== 0) {
// 				if ($in.val() !== '') {
// 					$(this).addClass("selected");
// 				} else {
// 					$(this).removeClass("selected");
// 				}
// 			}
// 		});
// 		$(".inputText").each(function () {
// 			var $in = $(this).find("input");
// 			if ($in.length !== 0) {
// 				if ($in.val() !== '') {
// 					$(this).addClass("filled");
// 				} else {
// 					$(this).removeClass("filled");
// 				}
// 			}
// 		});
// 	};

// 	geocoder.geocode({ 'address': coorUrl }, function (results, status) {
// 		if (cp === '') {
// 			geocoder.geocode({ 'location': results[0].geometry.location }, getLocation);
// 		} else {
// 			getLocation(results, status);
// 		}
// 	});
// }

function triggerEvent(el, etype) {
	var e;
	if (document.createEvent) {
		e = document.createEvent("HTMLEvents");
		e.initEvent(etype, true, true);
		el.dispatchEvent(e);
	} else {
		e = document.createEventObject();
		e.eventType = etype;
		el.fireEvent("on" + etype, e);
	}
}

function cbxName(cbx, name) {
	cbx.setAttribute("name", cbx.checked ? name : "");
}